import { render } from "./SearchVouchersView.vue?vue&type=template&id=5b5578b1"
import script from "./SearchVouchersView.vue?vue&type=script&lang=ts"
export * from "./SearchVouchersView.vue?vue&type=script&lang=ts"
script.render = render

export default script